import { useNavigate, useParams } from "react-router-dom";
import Report from "datasets/pages/dashboards/types/interfaces/report";
import { useFetcher } from "~/hooks/useFetcher";
import { ROUTE_404 } from "~/router/constants";

const { VITE_CATALOG_API } = import.meta.env;

const useReport = () => {
  const navigate = useNavigate();
  const { reportId } = useParams();

  const resp = useFetcher<Report>(reportId ? `${VITE_CATALOG_API}/reports/${reportId}` : null);

  if (resp.error?.status >= 400 && resp.error.status < 500) {
    navigate(ROUTE_404, { replace: true });
  }

  return resp;
};

export default useReport;
